var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-input-group",
    [
      _c("b-form-input", {
        class: {
          "is-invalid": _vm.isSubmitted && _vm.error,
          "br-none": !_vm.disabled,
        },
        attrs: {
          value: _vm.rendAddress(_vm.addressPayload),
          readonly: "",
          disabled: _vm.disabled,
        },
        on: {
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            $event.preventDefault()
          },
        },
      }),
      !_vm.disabled
        ? _c(
            "b-input-group-append",
            [
              _c(
                "b-input-group-text",
                {
                  staticClass:
                    "cursor-pointer bg-color-white input-group-text-bg-white",
                  class: {
                    "is-invalid": _vm.isSubmitted && _vm.error,
                  },
                },
                [
                  _vm.checkAddress === false
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.top",
                              modifiers: { hover: true, top: true },
                            },
                          ],
                          attrs: { title: _vm.FormMSG(12, "Add") },
                          on: { click: _vm.openAdresseModal },
                        },
                        [
                          _c(_vm.getLucideIcon("PlusCircle"), {
                            tag: "component",
                            attrs: {
                              color: "#00A09C",
                              size: 18,
                              "stroke-width": 2.25,
                            },
                          }),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass: "mr-2",
                            attrs: { title: _vm.FormMSG(13, "Update") },
                            on: { click: _vm.openAdresseModal },
                          },
                          [
                            _c(_vm.getLucideIcon("Edit"), {
                              tag: "component",
                              attrs: {
                                color: "#225CBD",
                                size: 18,
                                "stroke-width": 2.25,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            attrs: { title: _vm.FormMSG(14, "Delete") },
                            on: { click: _vm.handleDeleteAddress },
                          },
                          [
                            _c(_vm.getLucideIcon("X"), {
                              tag: "component",
                              attrs: {
                                color: "#EA4E2C",
                                size: 20,
                                "stroke-width": 2.75,
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-modal",
        {
          ref: "modal",
          attrs: {
            "header-class": "header-class-modal-doc-package",
            title: _vm.rendAddressTitle,
            size: "lg",
          },
          on: { hidden: _vm.handleAdressModalCancel },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "w-100 d-flex justify-content-end align-items-center",
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "w-138-px mr-3",
                          staticStyle: { "margin-top": "5px" },
                          attrs: {
                            size: "md",
                            variant: "custom-outline-gray",
                            block: "",
                          },
                          on: { click: _vm.handleAdressModalCancel },
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.FormMSG(3, "Cancel")) +
                              "\n\t\t\t\t"
                          ),
                        ]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "w-138-px",
                          attrs: { size: "md", variant: "primary", block: "" },
                          on: { click: _vm.handleAddressSubmit },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-content-center align-items-center",
                            },
                            [
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "1px" } },
                                [_vm._v(_vm._s(_vm.FormMSG(2, "Save")))]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.isAddressModalOpen,
            callback: function ($$v) {
              _vm.isAddressModalOpen = $$v
            },
            expression: "isAddressModalOpen",
          },
        },
        [
          _c(
            "div",
            { staticClass: "container-layout" },
            [
              _c("AddressForm", {
                attrs: {
                  "edit-data": _vm.addressPayload,
                  "is-submitted": _vm.isHitted,
                },
                on: {
                  "address-maplink-change": _vm.handleAddressMapLinkChange,
                  change: _vm.handleAdressChange,
                  "invalid:form": _vm.onInvalidForm,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }